import * as Preact from 'preact';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { OpenInNewIcon } from './icons';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var t = useTranslations().t;
    return (Preact.h(Box, { sx: { display: 'flex', justifyContent: 'space-between', paddingX: '6px' } },
        p.price && Preact.h(Typography, { variant: "h6" }, p.price),
        p.infoUrl && (Preact.h(Button, { variant: "text", size: "small", color: "info", endIcon: Preact.h(OpenInNewIcon, { fontSize: "small" }), sx: { fontSize: '12px', fontWeight: 700, padding: 0 }, href: p.infoUrl, onClick: function () { return p.price && p.trackMoreInfo(p.price); }, target: "_blank" }, t('product.card.more_info')))));
};
